import astra from './images/astra.png';
import breach from './images/breach.png';
import brimstone from './images/brimstone.png';
import chamber from './images/chamber.png';
import cypher from './images/cypher.png';

import jett from './images/jett.png';
import kayo from './images/kayo.png';
import killjoy from './images/killjoy.png';
import neon from './images/neon.png';
import omen from './images/omen.png';
import phoenix from './images/phoenix.png';
import raze from './images/raze.png';
import reyna from './images/reyna.png';
import sage from './images/sage.png';
import skye from './images/skye.png';
import sova from './images/sova.png';
import viper from './images/viper.png';
import yoru from './images/yoru.png';

const description = 'Valorant';
const rare = 'Muito Raro';

const initialCards = [
  { cardName: 'Astra',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: astra,
    cardRare: rare,
    cardTrunfo: false,
  },
  {
    cardName: 'Breach',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: breach,
    cardRare: rare,
    cardTrunfo: false,
  },
  {
    cardName: 'Brimstone',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: brimstone,
    cardRare: rare,
    cardTrunfo: false,
  },
  {
    cardName: 'Chamber',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: chamber,
    cardRare: rare,
    cardTrunfo: false,
  },
  {
    cardName: 'Cypher',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: cypher,
    cardRare: rare,
    cardTrunfo: false,
  },
  {
    cardName: 'Jett',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: jett,
    cardRare: rare,
    cardTrunfo: false,
  },
  {
    cardName: 'Kay/o',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: kayo,
    cardRare: rare,
    cardTrunfo: false,
  }, {
    cardName: 'Killjoy',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: killjoy,
    cardRare: rare,
    cardTrunfo: false,
  }, {
    cardName: 'Neon',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: neon,
    cardRare: rare,
    cardTrunfo: false,
  }, {
    cardName: 'Omen',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: omen,
    cardRare: rare,
    cardTrunfo: false,
  }, {
    cardName: 'Phoenix',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: phoenix,
    cardRare: rare,
    cardTrunfo: false,
  }, {
    cardName: 'Raze',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: raze,
    cardRare: rare,
    cardTrunfo: false,
  },
  {
    cardName: 'Reyna',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: reyna,
    cardRare: rare,
    cardTrunfo: false,
  },
  {
    cardName: 'Sage',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: sage,
    cardRare: rare,
    cardTrunfo: false,
  },
  {
    cardName: 'Skye',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: skye,
    cardRare: rare,
    cardTrunfo: false,
  },
  {
    cardName: 'Sova',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: sova,
    cardRare: rare,
    cardTrunfo: false,
  },
  {
    cardName: 'Viper',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: viper,
    cardRare: rare,
    cardTrunfo: false,
  },
  {
    cardName: 'Yoru',
    cardDescription: description,
    cardAttr1: '70',
    cardAttr2: '70',
    cardAttr3: '70',
    cardImage: yoru,
    cardRare: rare,
    cardTrunfo: false,
  },
];

export default initialCards;
